// Lógica pura do throttle do indicador "a escrever". Sem React, sem I/O.
// O throttle serve também de refresh: a Meta mostra o indicador ~25s, e ao
// reenviar a cada 15s (enquanto há teclas) mantemos o estado vivo sem buracos.

export const TYPING_THROTTLE_MS = 15_000;

export function shouldSendTyping(
  now: number,
  lastFiredAt: number,
  throttleMs: number = TYPING_THROTTLE_MS,
): boolean {
  return now - lastFiredAt >= throttleMs;
}
